import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.rounded)?_c(VChip,{attrs:{"color":_vm.labelColor,"label":"","small":"","outlined":""}},[_c(VIcon,{staticClass:"labelIcon",attrs:{"small":"","color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"labelText"},[_vm._v(_vm._s(_vm.text))])],1):_c('span',{attrs:{"text":"","small":""}},[_c(VIcon,{attrs:{"small":"","color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"infoText"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }